import { createFourierModel } from "./model";
import { dragonSingle } from "./shapes/dragonSingle";
export const dragonSingleModel = createFourierModel(dragonSingle, 0.88);
